import { Platform } from 'react-native';
import * as Linking from 'expo-linking';
import WebLinking from './Linking';

export default Platform.select({
  web: WebLinking,
  ios: Linking,
  android: Linking,
});
